<main>
  <p>{{data.message}}</p>
  <div>
  <app-button [outline]="true" (click)="cancel()">Cancelar</app-button>
	<app-button (click)="accept()">Aceptar</app-button>
  </div>
</main>
